import { FC, MouseEvent } from 'react';
import { Link } from 'react-router-dom';

import { IncentivesMarketBeneficiary } from 'modules/incentivesMarket/types';
import {
  getIncentivesMarketPartyImage,
  getIncentivesMarketPartyInitials,
} from 'modules/incentivesMarket/utils/getIncentivesMarketPartyDisplay';

export enum AvatarSize {
  XS = 'xs', // eslint-disable-line no-unused-vars
  SM = 'sm', // eslint-disable-line no-unused-vars
  MD = 'md', // eslint-disable-line no-unused-vars
  LG = 'lg', // eslint-disable-line no-unused-vars
  XL = 'xl', // eslint-disable-line no-unused-vars
}

type IncentivesMarketPartyLabelProps = {
  avatarSize?: AvatarSize;
  className?: string;
  linkTo?: string;
  onLinkClick?: (event: MouseEvent<HTMLAnchorElement>) => void; // eslint-disable-line no-unused-vars
  party: Pick<IncentivesMarketBeneficiary, 'name' | 'image'>;
};

const IncentivesMarketPartyLabel: FC<IncentivesMarketPartyLabelProps> = ({
  avatarSize = AvatarSize.XS,
  className = '',
  linkTo,
  onLinkClick,
  party,
}) => {
  const partyImage = getIncentivesMarketPartyImage(party);
  const partyInitials = getIncentivesMarketPartyInitials(party);

  return (
    <span className={`d-inline-flex align-items-center ${className}`.trim()}>
      <div
        className={`user-avatar user-avatar-${avatarSize} bg-info-dim mr-1 fs-12px`}
      >
        {partyImage ? (
          <img src={partyImage} alt={party.name} />
        ) : (
          <span>{partyInitials}</span>
        )}
      </div>
      {linkTo ? (
        <Link to={linkTo} className="text-primary" onClick={onLinkClick}>
          {party.name}
        </Link>
      ) : (
        <span className="text-primary">{party.name}</span>
      )}
    </span>
  );
};

export default IncentivesMarketPartyLabel;
